// @owners { team: patient-fulfillment }
import { createSelector } from 'reselect';
import { getOnboardingInsuranceID } from './getOnboarding';
import { getInsurances } from '~shared/features/insurances/selectors/getInsurances';

export const getSavedOnboardingInsurance = createSelector(
  [getOnboardingInsuranceID, getInsurances],
  (onboardingInsuranceID, insurances) => {
    return insurances.find(({ id }) => id === onboardingInsuranceID);
  },
);
